import React from 'react';
import classNames from 'classnames';

import { Button, SecondaryButton } from '../../components';
import { HiLightBulb } from 'react-icons/hi';
import config from '../../config';

import { injectIntl } from '../../util/reactIntl';
import css from './SignupProviderForms.css';

import enImg from '../../assets/signup-provider-work-experience-info-en.png';
import fiImg from '../../assets/signup-provider-work-experience-info-fi.png';

const SignupProviderWorkExperienceInfoStep = props => {
  const { onSubmit, onPrev, intl, rootClassName, className } = props;

  const classes = classNames(rootClassName || css.root, className);
  const locale = config.locale || 'fi';

  const heading = intl.formatMessage({ id: 'SignupProviderForms.workExperienceInfoHeading' });
  const description = intl.formatMessage({
    id: 'SignupProviderForms.workExperienceInfoDescription',
  });
  const workExperienceTitle = intl.formatMessage({
    id: 'SignupProviderForms.workExperienceInfoWorkTitle',
  });
  const workExperienceDescription = intl.formatMessage({
    id: 'SignupProviderForms.workExperienceInfoWorkDescriptionText',
  });
  const workedWithTitle = intl.formatMessage({
    id: 'SignupProviderForms.workExperienceInfoWorkedWithTitle',
  });
  const workedWithDescription = intl.formatMessage({
    id: 'SignupProviderForms.workExperienceInfoWorkedWithDescription',
  });
  const portfolioTip = intl.formatMessage({
    id: 'SignupProviderForms.workExperienceInfoPortfolioTip',
  });
  const nextButtonText = intl.formatMessage({ id: 'SignupProviderForms.nextUpWorkExperience' });
  const previousButtonText = intl.formatMessage({ id: 'SignupProviderForms.previousButton' });

  const imageSrc = locale === 'en' ? enImg : fiImg;

  return (
    <div className={classes}>
      <div className={css.form}>
        <div className={css.formFieldsContainer}>
          <div className={css.introContainer}>
            <div className={css.infoDescription}>
              <h2 className={css.mainHeading}>{heading}</h2>
              <p className={css.workExperienceInfoDescription}>{description}</p>
              <div className={css.workExperienceInfoBlock}>
                <h3 className={css.workExperienceInfoBlockHeading}>{workExperienceTitle}</h3>
                <p className={css.workExperienceInfoBlockText}>{workExperienceDescription}</p>
              </div>
              <div className={css.workExperienceInfoBlock}>
                <h3 className={css.workExperienceInfoBlockHeading}>{workedWithTitle}</h3>
                <p className={css.workExperienceInfoBlockText}>{workedWithDescription}</p>
              </div>
              <div className={css.workExperiencePortfolioTip}>
                <HiLightBulb className={css.workExperiencePortfolioTipIcon} />
                <div className={css.workExperiencePortfolioTipText}>{portfolioTip}</div>
              </div>
            </div>
            <div className={css.workExperienceInfoImageContainer}>
              <img src={imageSrc} alt="Signup Intro" className={css.introImage} />
            </div>
          </div>
        </div>
        <div className={css.submitContainer}>
          <SecondaryButton rootClassName={css.backButton} onClick={onPrev}>
            {previousButtonText}
          </SecondaryButton>
          <Button rootClassName={css.nextButton} onClick={onSubmit}>
            {nextButtonText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(SignupProviderWorkExperienceInfoStep);
